import { z } from 'zod';

import { ModalSessionCorporateSelectionSchema } from './booking_request_info';
import { ModalSessionTravelerInputSchema } from './session';

/**
 * Snapshot do checkout de uma reserva — projeção do booking request que o
 * modal-session persiste na Order do trip service. A 2ª compra da mesma trip lê
 * este snapshot para pré-preencher o checkout (spec 2026-08-28). Guarda IDS de
 * CC/motivo (não nomes): o cliente resolve display contra o booking form fresco,
 * o que também invalida ids stale. Travelers ficam no shape exato enviado ao
 * modal-session (voo é rico; hotel é name-only — a completude fica a cargo do
 * `computeCanSubmit` do genui-kit).
 */
export const CheckoutSnapshotSchema = z
  .object({
    productType: z.enum(['flight', 'hotel']),
    requesterId: z.string().min(1),
    travelers: z.array(ModalSessionTravelerInputSchema).min(1),
    corporateSelection: ModalSessionCorporateSelectionSchema.optional(),
    observation: z.string().max(300).optional(),
    capturedAt: z.iso.datetime(),
  })
  .strict();
export type CheckoutSnapshot = z.infer<typeof CheckoutSnapshotSchema>;
